<div *ngIf="!b64String" style="border-radius:{{borderRadiusRem}}rem;" class="image"></div>
<img *ngIf="b64String" style="border-radius:{{borderRadiusRem}}rem;" [src]="b64String" class="image">
